<template>
  <el-dialog title="开店" :visible.sync="dialogVisible" width="70%" @close="clearAddShopInfo">
    <el-form :model="addShopInfo" label-width="120px" ref="addShopForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商铺名称" prop="shopName" required>
            <el-input v-model="addShopInfo.shopName" placeholder="必填，请填写商铺名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商铺类型" prop="shopType" required>
            <el-select v-model="addShopInfo.shopType" placeholder="必填，请选择商铺类型" @change="_changeAddShopType"
              style="width:100%">
              <el-option v-for="item in shopInfo.shopTypes" :key="item.shopTypeId" :label="item.typeName"
                :value="item.shopTypeId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="店铺地区" required>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-select v-model="addShopInfo.selectProv" placeholder="请选择省" @change="getProv" style="width:100%">
              <el-option v-for="item in addShopInfo.provs" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6" v-if="addShopInfo.selectProv">
            <el-select v-model="addShopInfo.selectCity" placeholder="请选择城市" @change="getCity" style="width:100%">
              <el-option v-for="item in addShopInfo.citys" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6" v-if="addShopInfo.selectCity">
            <el-select v-model="addShopInfo.areaCode" placeholder="请选择区县" style="width:100%">
              <el-option v-for="item in addShopInfo.areas" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="开店类型" prop="openType" required>
            <el-select v-model="addShopInfo.openType" placeholder="必填，请选择开店类型" style="width:100%">
              <el-option v-for="item in addShopInfo.openTypes" :key="item.statusCd" :label="item.name"
                :value="item.statusCd"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商铺logo" prop="shopLogo" required>
            <upload-image-url ref="uploadImage" :imageCount="1"
              @notifyUploadCoverImage="handleUploadImage"></upload-image-url>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="addShopInfo.accountBondAmount">
        <el-col :span="12">
          <el-form-item label="保证金金额">
            <el-input v-model="addShopInfo.accountBondAmount" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商铺描述" prop="shopDesc" required>
            <el-input type="textarea" v-model="addShopInfo.shopDesc" placeholder="必填，请填写商铺描述"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货地址" prop="sendAddress" required>
            <el-input type="textarea" v-model="addShopInfo.sendAddress" placeholder="必填，请填写发货地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="退货联系人" prop="returnPerson" required>
            <el-input v-model="addShopInfo.returnPerson" placeholder="必填，请填写退货联系人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退货联系电话" prop="returnLink" required>
            <el-input v-model="addShopInfo.returnLink" placeholder="必填，请填写退货联系电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="退货地址" prop="returnAddress" required>
        <el-input type="textarea" v-model="addShopInfo.returnAddress" placeholder="必填，请填写退货地址"></el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="坐标X位置" prop="mapX" required>
            <el-input v-model="addShopInfo.mapX" placeholder="请点击地图获取坐标" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="坐标Y位置" prop="mapY" required>
            <el-input v-model="addShopInfo.mapY" placeholder="请点击地图获取坐标" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="定位">
        <select-map-pos ref="selectMapPos" @position-change="handlePositionChange"></select-map-pos>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveShopInfo">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
        <span style="margin-left: 20px; color: #999;">
          保存成功后，管理员审核通过即可使用。
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getAreas, saveShop,listShopTypes } from '@/api/shop/shopApi'
import {queryAccountBond} from '@/api/admin/accountBondApi'
import { getDict } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import SelectMapPos from '@/components/system/selectMapPos'

export default {
  components: {
    UploadImageUrl,
    SelectMapPos
  },
  data() {
    return {
      dialogVisible: false,
      addShopInfo: {
        shopName: '',
        shopLogo: '',
        shopType: '',
        openType: '',
        shopDesc: '',
        sendAddress: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        accountBondAmount: '',
        mapX: '',
        mapY: '',
        accountBonds: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        areaCode: '',
        areas: [],
        provs: [],
        citys: [],
        openTypes: [],
        communitys: [],
      },
      shopInfo: {
        shopTypes: []
      },
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._initArea('101', '0')
      this.queryShopTypes()
      this.getDictData()
      setTimeout(() => {
        this.$refs.selectMapPos.initMap({})
        this.clearAddShopInfo()
      }, 100)
    },
    async queryShopTypes() {
      const res = await listShopTypes({page: 1, row: 100})
      this.shopInfo.shopTypes = res.data
    },
    async getDictData() {
      try {
        const { data } = await getDict('s_shop', 'open_type')
        this.addShopInfo.openTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
   
    handleUploadImage(param) {
      console.log(param)
      if (param.length > 0) {
        this.addShopInfo.shopLogo = param[0]
      } else {
        this.addShopInfo.shopLogo = ''
      }
    },
    async _listAddAccountBonds(shopTypeId) {
      try {
        const res = await queryAccountBond({
          page: 1,
          row: 100,
          bondType: '6006',
          objId: shopTypeId
        })
        this.addShopInfo.accountBonds = res.data
        if (res.data.length === 0) {
          this.$message.warning("请联系管理员设置该商铺类型的保证金！")
          return
        }
        this.addShopInfo.accountBondAmount = res.data[0].amount
      } catch (error) {
        console.error(error)
      }
    },
    _changeAddShopType(shopTypeId) {
      this.addShopInfo.shopRangeSel = []
      this.addShopInfo.accountBondAmount = ''
      this._listAddAccountBonds(shopTypeId)
    },
    async _initArea(areaLevel, parentAreaCode) {
      try {
        const res = await getAreas({
          areaLevel,
          parentAreaCode
        })
        const areas = res.data
        if (areaLevel === '101') {
          this.addShopInfo.provs = areas
        } else if (areaLevel === '202') {
          this.addShopInfo.citys = areas
        } else {
          this.addShopInfo.areas = areas
        }
      } catch (error) {
        console.error(error)
        this.$message.error("查询地区失败")
      }
    },
    getProv(prov) {
      this._initArea('202', prov)
    },
    getCity(city) {
      this._initArea('303', city)
    },
    clearAddShopInfo() {
      this.$refs.uploadImage.clearImages()
      const openTypes = this.addShopInfo.openTypes
      this.addShopInfo = {
        shopName: '',
        shopLogo: '',
        shopType: '',
        openType: '',
        shopDesc: '',
        sendAddress: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        accountBondAmount: '',
        mapX: '',
        mapY: '',
        accountBonds: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        areaCode: '',
        areas: [],
        provs: [],
        citys: [],
        openTypes: openTypes,
        communitys: [],
      }
      console.log(this.addShopInfo.communitys)
    },
    handlePositionChange(position) {
      this.addShopInfo.mapX = position.lng
      this.addShopInfo.mapY = position.lat
    },
    async saveShopInfo() {
      try {
        const valid = await this.$refs.addShopForm.validate()
        if (!valid) return

        if (!this.addShopInfo.accountBondAmount) {
          this.addShopInfo.accountBondAmount = ''
          this.$message.warning("请联系管理员设置该商铺类型的保证金！")
          return
        }

        const res = await saveShop(this.addShopInfo)
        if (res.code === 0) {
          this.dialogVisible = false
          this.clearAddShopInfo()
          this.$emit('listShop')
          this.$message.success("开店成功")
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>